import React from 'react';
import { useHistory } from 'react-router-dom';
import { isNativeApp } from '../../util/platformDetection';

const PrivacyMobile = () => {
  const history = useHistory();

  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      backgroundColor: '#000',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      paddingTop: 'env(safe-area-inset-top)'
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: '#1a1a1a',
        borderBottom: '1px solid #333',
        padding: '15px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <h2 style={{
          color: 'gold',
          margin: 0,
          fontSize: '24px',
          fontWeight: 'bold'
        }}>
          Privacy Policy
        </h2>
        <button
          onClick={() => history.goBack()}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: '#888',
            fontSize: '28px',
            cursor: 'pointer',
            padding: '5px'
          }}
        >
          ✕
        </button>
      </div>

      {/* Content */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        padding: '20px',
        paddingBottom: 'calc(env(safe-area-inset-bottom) + 20px)'
      }}>
        <div style={{ color: '#ccc', lineHeight: '1.6', fontSize: '16px' }}>
          <p style={{ textAlign: 'center', color: '#888', fontSize: '14px', marginBottom: '30px' }}>
            Last updated: August 26th, 2025
          </p>
          
          <p style={{ marginBottom: '20px' }}>
            This Privacy Policy outlines how ChessThread ("we," "our," "us") collects, uses, and protects your information. ChessThread.com is a social media platform dedicated to sharing and interacting with other users and chess content, including user-generated games, commentary, and interaction. By using the platform, you agree to the terms of this policy.
          </p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            1. Information We Collect
          </h3>
          <p>We may collect and store the following data:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
            <li>Account Data: Email address, username, and password (hashed)</li>
            <li>User Activity: Uploaded games, comments, likes, reports, interactions, and more</li>
            <li>Device Metadata: IP address, browser type, and general usage analytics</li>
            <li>Payment Information: If premium features are added, payments are processed by Stripe. We do not store card details—only the necessary Stripe customer ID to verify subscriptions</li>
          </ul>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            2. How We Use Your Information
          </h3>
          <p>We use your data to:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
            <li>Create and manage your account</li>
            <li>Display and host your submitted content</li>
            <li>Communicate with you (e.g., notifications, updates)</li>
            <li>Monitor and enforce community standards</li>
            <li>Analyze platform performance and detect abuse</li>
            <li>Maintain platform integrity</li>
          </ul>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            3. Data Sharing
          </h3>
          <p>We do not sell your information.</p>
          <p>We may share your data only with:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
            <li>Stripe for processing payments</li>
            <li>Secure infrastructure services for hosting, authentication, and storage</li>
            <li>Moderators as needed to resolve user reports or enforce terms</li>
            <li>Legal authorities, if required by law or valid legal request</li>
          </ul>
          <p>All third-party services are bound by confidentiality and data protection obligations.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            4. Data Retention
          </h3>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
            <li>Account and content data are stored as long as your account is active.</li>
            <li>Upon account deletion, we may delete or anonymize some or all associated account data where technically feasible.</li>
            <li>Certain residual data (e.g., backups or logs) may persist briefly for security and recovery purposes.</li>
          </ul>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            5. User Rights
          </h3>
          <p>You may:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
            <li>Request access to your data</li>
            <li>Request correction or deletion of your data</li>
            <li>Delete your account directly through the app settings, or by contacting info@chessthread.com</li>
          </ul>
          <p>We respond to all verified requests within 30 days. Identity confirmation may be required.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            6. Data Security
          </h3>
          <p>We use:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
            <li>Encrypted HTTPS connections</li>
            <li>Password hashing and secure authentication</li>
            <li>Rate-limiting and abuse prevention mechanisms</li>
          </ul>
          <p>While no system is impenetrable, we apply industry-standard practices to protect your data.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            7. Cookies and Tracking
          </h3>
          <p>We use minimal cookies for:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
            <li>Session authentication</li>
            <li>Site preferences (e.g., theme)</li>
            <li>Anonymous usage statistics (non-personally identifiable)</li>
          </ul>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            8. Children's Privacy
          </h3>
          <p>ChessThread is not intended for children under the age of 13. We do not knowingly collect or store data from anyone under this age. If such data is discovered, it will be deleted.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            9. Changes to This Policy
          </h3>
          <p>We may update this Privacy Policy from time to time. If significant changes are made, we will notify users via the platform or email. Continued use after updates constitutes acceptance.</p>

          <h3 style={{ color: 'gold', fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px' }}>
            10. Contact
          </h3>
          <p>For privacy-related questions or requests, contact:</p>
          <p style={{ fontWeight: 'bold' }}>Email: info@chessthread.com</p>
          <p style={{ marginTop: '20px', fontStyle: 'italic' }}>
            Use of ChessThread.com constitutes agreement with this Privacy Policy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyMobile;